export const FONT_FAMILY = {
  default: {
    regular: 'hellix-regular',
    bold: 'hellix-bold'
  },
  hellix: {
    regular: 'hellix-regular',
    bold: 'hellix-bold'
  }
};
